module.exports = __webpack_public_path__ + "img/img4.0a6a9694.png";